module.exports = __webpack_public_path__ + "img/resource-ky-active.a855de3a.png";